import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  activateChatbotLicenceService,
  chatbotThreadSendFeedbackService,
  getChatbotBusinessesAnalyticsService,
  getChatbotLicenceBusinessessService,
} from '../../services/chatbotAnalyticsService';

export const getChatbotLicenceBusinessessThunk = createAsyncThunk(
  'chatbotAnalytics/getChatbotLicenceBusinessess',
  async (payload, { getState, rejectWithValue }) => {
    try {
      const response = await getChatbotLicenceBusinessessService();

      return response;
    } catch (error) {
      return rejectWithValue('Failed to getChatbotLicenceBusinessessThunk');
    }
  }
);

export const getChatbotBusinessesAnalyticsThunk = createAsyncThunk(
  'chatbotAnalytics/getChatbotBusinessesAnalyticsThunk',
  async (payload, { getState, rejectWithValue }) => {
    try {
      const response = await getChatbotBusinessesAnalyticsService(
        payload.businessId,
        payload.yearMonth
      );

      return response;
    } catch (error) {
      return rejectWithValue('Failed to getChatbotBusinessesAnalyticsThunk');
    }
  }
);

export const chatbotThreadSendFeedbackThunk = createAsyncThunk(
  'chatbotAnalytics/chatbotThreadSendFeedbackThunk',
  async (payload, { getState, rejectWithValue }) => {
    try {
      const response = await chatbotThreadSendFeedbackService(
        payload.businessId,
        payload.yearMonth,
        payload.feedback
      );

      return response;
    } catch (error) {
      console.log('Error chatbotThreadSendFeedbackThunk');

      return rejectWithValue('Failed to chatbotThreadSendFeedbackThunk');
    }
  }
);

export const activateChatbotLicenceThunk = createAsyncThunk(
  'chatbotAnalytics/activateChatbotLicence',
  async (payload, { getState, rejectWithValue }) => {
    try {
      const response = await activateChatbotLicenceService(payload);

      return response;
    } catch (error) {
      return rejectWithValue('Failed to activateChatbotLicenceThunk');
    }
  }
);
